import * as rules from '../../../../shared/src/rules/economy';
import { content, type Recipe } from '../content';
import { TileEntityType } from '../../../../shared/src/constants';
import type { ItemStack } from './items';
export * from '../../../../shared/src/rules/economy';
export const Vendor = {
  ...rules.Vendor,
  sellValue: (s: ItemStack) => rules.Vendor.sellValue(s, content()),
  isJunk: (s: ItemStack) => rules.Vendor.isJunk(s, content()),
};
export const allRecipes = () => rules.allRecipes(content());
export const recipesFor = (station: TileEntityType) => rules.recipesFor(station, content());
export const recipeName = (r: Recipe) => rules.recipeName(r, content());
